export const RoutePath = {
  Home: '/home',
  Document: '/document/*',
  Recent: '/document/recent',
  OneDrive: '/document/oneDrive',
  TeamsChannels: '/document/teamsChannels',
  Viewer: '/viewer/',
  SignViewer: '/sign-viewer/',
  JobHistory: '/job-history',
  RedactEdit: '/redact-edit',
  AllTools: '/all-tools',
}

export const HeaderActiveLink = {
  [RoutePath.Home]: 'Home',
  [RoutePath.Document]: 'Document',
  [RoutePath.Recent]: 'Recent',
  [RoutePath.Viewer]: 'Edit PDF',
  [RoutePath.SignViewer]: 'Sign PDF',
  [RoutePath.JobHistory]: 'Job History',
  [RoutePath.RedactEdit]: 'Redact Edit',
  [RoutePath.AllTools]: 'All Tools',
}

export const routeDocumentTabMap = {
    Recent: '/recent',
    OneDrive: '/oneDrive',
    TeamsChannel: '/teamsChannel',
}